import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { C2Button, C2Section, C2Shape } from '../c2';

interface BottomCTAProps {
  title: string;
  titleAccent?: string;
  sub?: string;
  primaryLabel?: string;
  primaryTo?: string;
  primaryHref?: string;
}

function renderTitle(title: string, accent?: string): ReactNode {
  if (!accent || !title.includes(accent)) return title;
  const i = title.indexOf(accent);
  return (
    <>
      {title.slice(0, i)}
      <span style={{ color: 'var(--accent-soft)' }}>{accent}</span>
      {title.slice(i + accent.length)}
    </>
  );
}

export default function BottomCTA({
  title,
  titleAccent,
  sub,
  primaryLabel = 'Get started — free forever',
  primaryTo = '/gatekeeper',
  primaryHref,
}: BottomCTAProps) {
  return (
    <C2Section pad={80}>
      <div
        className="rounded-xl text-center relative overflow-hidden max-w-[960px] mx-auto"
        style={{ background: 'var(--color-ink)', color: '#fff', padding: '64px clamp(24px, 4vw, 48px)' }}
      >
        <C2Shape shape="circle" size={260} color="peach" className="absolute opacity-[0.15]" style={{ top: -80, left: -60 }} />
        <C2Shape shape="circle" size={200} color="sky" className="absolute opacity-[0.15]" style={{ bottom: -80, right: -40 }} />
        <div className="relative">
          <h2
            className="font-display font-extrabold m-0"
            style={{ fontSize: 44, letterSpacing: '-0.02em', lineHeight: 1.1 }}
          >
            {renderTitle(title, titleAccent)}
          </h2>
          {sub && (
            <p
              className="leading-[1.55] mt-4 mx-auto max-w-[460px]"
              style={{ fontSize: 17, color: 'rgba(255,255,255,0.72)' }}
            >
              {sub}
            </p>
          )}
          <div className="mt-8 flex gap-3 justify-center flex-wrap">
            {primaryHref ? (
              <a href={primaryHref} target="_blank" rel="noopener noreferrer">
                <C2Button variant="accent" size="lg">{primaryLabel}</C2Button>
              </a>
            ) : (
              <Link to={primaryTo}>
                <C2Button variant="accent" size="lg">{primaryLabel}</C2Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </C2Section>
  );
}
